var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#773adc",
    d: "M13.13 2.4v4.59L9.18 9.3V4.7l3.95-2.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.45 4.71c.55-.32 1-.07 1 .56a2.18 2.18 0 01-1 1.72c-.55.32-1 .07-1-.57a2.17 2.17 0 011-1.71z",
    fill: "#552f99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#773adc",
    d: "M7.9 11v4.59L3.95 17.9v-4.6L7.9 11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92 13.53c.55-.31 1-.06 1 .57a2.2 2.2 0 01-1 1.72c-.55.32-1 .06-1-.57a2.2 2.2 0 011-1.72z",
    fill: "#552f99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#a67af4",
    d: "M3.95 13.3v4.6L0 15.59V11l3.95 2.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#773adc",
    d: "M18 11.01v4.59l-3.95 2.31v-4.6l3.95-2.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.49 6.2a4.17 4.17 0 012.37 2.61l.19-.11 1 .58a5.21 5.21 0 00-3.15-4.06.53.53 0 00-.41 1z",
    fill: "#32bedd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#a67af4",
    d: "M14.05 13.32v4.59L10.1 15.6v-4.59l3.95 2.31z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.19 13.59c-.52-.3-.94-.05-.94.54a2.08 2.08 0 00.94 1.63c.52.3.94.06.94-.54a2.08 2.08 0 00-.94-1.63z",
    fill: "#552f99"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 16.11a5.46 5.46 0 01-3.18-1 .55.55 0 11.64-.89 4.36 4.36 0 004.81.18.55.55 0 11.58.94 5.54 5.54 0 01-2.85.77z",
    fill: "#32bedd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#b796f9",
    d: "M13.13 2.4L9.19 4.71 5.24 2.4 9.19.09l3.94 2.31z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24 5.3a5.25 5.25 0 00-2.36 4L4 8.69v.05a4.2 4.2 0 011.24-2.07z",
    fill: "#32bedd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#b796f9",
    d: "M18 11.01l-3.95 2.31-3.95-2.31 3.95-2.31L18 11.01zM7.9 11l-3.95 2.3L0 11l3.95-2.31L7.9 11z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#a67af4",
    d: "M9.18 4.71V9.3L5.24 6.99V2.4l3.94 2.31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoster);
export default __webpack_public_path__ + "static/media/poster.01ce77c2186f9d3bf3f1f0ee3acab1e6.svg";
export { ForwardRef as ReactComponent };